import { get } from 'lodash';

import { Toast } from 'antd-mobile';
// import { history } from 'umi';
import {
  referralAchievementsDXP,
  qryInviteeListDXP,
  qryInviteeDetailDXP,
  qrySubscribersDXP,
} from '../services';
import { getMyAchieveRewardsDXP } from '@/services';
import { normalizeDXPRewardList, showModelError } from '@/utils/rewardModel';

export default {
  namespace: 'postPaidC2c',
  state: {
    pageRenderDetail: {}, // 页面渲染配置JSON详情
    referralInfo: {}, // 推荐详情
    selectedCustName: '', // 选中的客户名称
  },

  reducers: {
    save(state, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    *qryInviteeListDXP({ payload }, { call }) {
      try {
        const resp = yield call(qryInviteeListDXP, payload);
        const {
          resultCode,
          resultMsg,
          data: dataList,
          totalCount,
          pageSize,
          pageIndex,
        } = resp || {};
        const dataTemp = (dataList || []).map(data => ({
          ...data,
          custName: data.userName,
          invitationStatus: data.invitationState,
          invitationStatusCSS: data.invitationStateCSS,
          actionList: data?.actionList?.map(action => ({
            ...action,
            promotionName: action.actionName,
            invitationStatus: action.invitationState,
            invitationStatusCSS: action.invitationStateCSS,
            promReferInstId: action.promoReferInstId,
            rewardList: action?.rewardList?.map(reward => ({
              ...reward,
              receiveDeadDate: reward.deadLine,
              telcoFlag: reward.isTelco ? 'Y' : 'N',
            })),
          })),
        }));
        // 0表示成功
        if (resultCode === '0') {
          return {
            data: {
              inviteeList: dataTemp,
            },
            pageInfo: {
              currentPage: pageIndex,
              pageNum: pageIndex,
              pageSize,
              total: totalCount,
            },
          };
        }
        Toast.show({ icon: 'fail', content: resultMsg });
        return {};
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
    *qryInviteeDetailDXP({ payload }, { call }) {
      try {
        const resp = yield call(qryInviteeDetailDXP, payload);
        const { resultCode, resultMsg, data, pageInfo } = resp || {};
        // 0表示成功
        if (resultCode === '0') {
          return {
            data: {
              actionList: data?.map(item => ({
                ...item,
                promotionName: item.actionName,
                partnerSn: item.transactionSn,
                invitationStatus: item.invitationState,
                invitationStatusCSS: item.invitationStateCSS,
                referrerRewardList: item?.referrerRewardList?.map(referrerReward => ({
                  ...referrerReward,
                  receiveDeadDate: referrerReward.deadLine,
                })),
              })),
            },
            pageInfo,
          };
        }
        Toast.show({ icon: 'fail', content: resultMsg });
        return {};
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
    *qrySubscribersDXP({ payload }, { call }) {
      try {
        const resp = yield call(qrySubscribersDXP, payload);
        const { resultCode, resultMsg, data } = resp || {};
        // 0表示成功
        if (resultCode === '0') {
          return data || [];
        }
        Toast.show({ icon: 'fail', content: resultMsg });
        return [];
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return [];
      }
    },
    *referralAchievementsDXP({ payload }, { call, put }) {
      try {
        const resp = yield call(referralAchievementsDXP, payload);
        const { resultCode, resultMsg, data = {} } = resp || {};
        // 0表示成功
        if (resultCode === '0') {
          yield put({
            type: 'save',
            payload: {
              referralInfo: {
                ...data,
                inviteSuccessNum: data.invitesSuccessCount,
                rewardNum: data.rewardCount,
                earnPointList: (data.pointList || []).map(item => ({
                  ...item,
                  earnPointNum: item.pointAmount,
                })),
              },
            },
          });
          return data;
        }
        Toast.show({ icon: 'fail', content: resultMsg });
        return {};
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
    *getMyAchieveRewardsDXP({ payload }, { call }) {
      try {
        const resp = yield call(getMyAchieveRewardsDXP, payload);
        const data = get(resp, 'data') || [];
        const code = get(resp, 'resultCode');
        const retDesc = get(resp, 'resultMsg');
        // 0表示成功
        if (code === '0') {
          return {
            data: normalizeDXPRewardList(data),
          };
        }
        return showModelError(retDesc, {});
      } catch (e) {
        return showModelError(e.Error, {});
      }
    },
  },
};
